import React, { useEffect, useRef } from "react";
import SVG from "react-inlinesvg";
import { Modal } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { formatAmount, formatDate, permissionAllow, statusColourName } from "../../../../util/Helpers";
import { PermissionType, Permissions } from "../../../../util/Permissions";
import { useSelector } from "react-redux";
import { useApproveOrderMutation, useCancelOrderMutation } from "../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";

const ViewOrderModal = ({ showViewOrderModal, details, onHide, tableRef }) => {

    const adminUser = useSelector(state => state.auth.user);


    const progress = details?.progress?.map((row, i) =>
        <div key={`progres-${i}`} className="timeline-item align-items-start">
            {/*begin::Badge--> */}
            <div className="timeline-badge">
                <i className={`fa fa-genderless text-${statusColourName(row.status)} icon-xl`} />
            </div>
            {/*end::Badge--> */}
            {/*begin::Content--> */}
            <div className="timeline-content d-flex">
                <span className="font-weight-bolder text-dark-75 pl-3 font-size-lg">{row.status}</span>
                <span className="font-weight-bolder text-muted pl-5 font-size-lg">{formatDate(row.time)}</span>
            </div>
            {/*end::Content--> */}
        </div>
    );
    const [
        approveOrder,
        {
            isLoading: isApproving
        }
    ] = useApproveOrderMutation()


    /* Approve Order */
    const approve = () => {
        const { progress, status } = details

        approveOrder({
            id: details?.id,
            userId: details.userId,
            meta: {
                progress,
                status,
            }

        })
            .unwrap()
            .then(() => {
                cogoToast.success("Order Approved Successfully")
                onHide();
                if (tableRef) {
                    tableRef.current.refresh()
                }

            })
    }
    const [
        cancelOrder,
        {
            isLoading: isCancelling
        }
    ] = useCancelOrderMutation()

    const cancel = () => {
        const { progress, status } = details

        cancelOrder({
            id: details?.id,
            userId: details.userId,
            meta: {
                progress,
                status,
            }

        })
            .unwrap()
            .then(() => {
                cogoToast.success("Order Declined Successfully")
                onHide();
                if (tableRef) {
                    tableRef.current.refresh()
                }

            })
    }

    return (
        <Modal
            show={showViewOrderModal}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
        >

            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                        <SVG
                            title=""
                            src={toAbsoluteUrl("/media/svg/icons/Shopping/Cart3.svg")}
                        />
                    </span>
                    Order Details
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>
            <Modal.Body
                className="px-10 py-2"
            >
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>ID</h6>
                        <span className="text-muted">{details?.id}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Ref ID</h6>
                        <span className="text-muted">{details?.refid}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Instrument ID</h6>
                        <span className="text-muted">{details?.instrumentId}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>Status</h6>
                        <span className="text-muted">{details?.status}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Side</h6>
                        <span className="text-muted">{details?.side}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Type</h6>
                        <span className="text-muted">{details?.type}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-4 py-4">
                        <h6>Symbol</h6>
                        <span className="text-muted">{details?.symbol}</span>
                    </div>
                    <div className="col-lg-4 py-4">
                        <h6>Quantity</h6>
                        <span
                            className="text-muted">{details?.quantity?.toLocaleString(undefined, { maximumFractionDigits: 10 })}</span>
                    </div>
                    <div className="col-lg-4 py-4">
                        <h6>Country</h6>
                        <span className="text-muted">{details?.country}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>Price per Share</h6>
                        <span className="text-muted">{formatAmount(details?.currency, details?.price)}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Amount</h6>
                        <span className="text-muted">{formatAmount(details?.currency, details?.amount)}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Total</h6>
                        <span className="text-muted">{formatAmount(details?.currency, details?.total)}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>Exchange</h6>
                        <span className="text-muted">{details?.exchange}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Provider</h6>
                        <span className="text-muted">{details?.provider}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Created</h6>
                        <span className="text-muted">{formatDate(details?.created)}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>CHN</h6>
                        <span className="text-muted">{details?.chnNo || "NA"}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>CSCS</h6>
                        <span className="text-muted">{details?.cscsNo || "NA"}</span>
                    </div>
                </div>
                {
                    details?.response && details?.response?.error ?

                        <div className="row">
                            <div className="col-lg py-4">
                                <h6 className="text-danger">Error Message</h6>
                                <span className="text-muted">{details.response.error}</span>
                            </div>
                        </div>
                        :

                        ""
                }
                <h4 className="mt-5 text-primary">Order Status Progress</h4>
                <div className="mb-5 pb-5">
                    {
                        progress?.length === 0
                            ? <span className="text-muted">Nil</span>
                            : <div className="timeline timeline-7 mt-5">{progress}</div>
                    }
                </div>
                <h4 className={"mb-4 mt-5"}>Response</h4>
                <div className="pb-5 overflow-auto">
                    {JSON.stringify(details?.response)}
                </div>
                <div className="row">
                    <div className="col-lg">
                        <h4 className="mb-4 pt-5 mt-5 text-muted h5">Fee Details</h4>
                        <div className="text-muted bg-light-secondary rounded-lg p-4 overflow-auto" style={{ maxHeight: "300px" }}>
                            <pre className="mb-0">{JSON.stringify(details?.fees, null, 4)}</pre>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg">
                        <h4 className="mb-4 pt-5 mt-5 text-muted h5">More Details</h4>
                        <div className="text-muted bg-light-secondary rounded-lg p-4 overflow-auto" style={{ maxHeight: "300px" }}>
                            <pre className="mb-0">{JSON.stringify(details, null, 4)}</pre>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                {
                    (
                        (
                            (details?.status === "ON_HOLD")

                        ) &&
                        permissionAllow(adminUser, Permissions.ORDERS, PermissionType.UPDATE)
                    ) ? <>
                        <button
                            type="button"
                            disabled={isApproving}
                            onClick={approve}
                            className={`btn btn-primary btn-elevate px-5 ml-5`}
                        >
                            Approve
                        </button>

                        <button
                            type="button"
                            disabled={isCancelling}
                            onClick={cancel}
                            className="btn btn-danger btn-elevate px-5 ml-5"
                        >
                            Decline
                        </button>


                    </>
                        : <>
                            <button
                                type="button"
                                onClick={onHide}
                                className="btn btn-secondary btn-elevate px-5"
                            >
                                Okay
                            </button>
                        </>
                }

            </Modal.Footer>
        </Modal>

    );
}

export default ViewOrderModal;